// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/event_type.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BoolValue, proto3, Timestamp } from "@bufbuild/protobuf";
import { EventLocation } from "./event_location_pb.js";
import { PeriodType } from "../../enum/v1/period_type_pb.js";
import { SchedulingType } from "../../enum/v1/scheduling_type_pb.js";
import { AttendanceType } from "../../enum/v1/attendance_type_pb.js";
import { Media } from "./media_pb.js";

/**
 * @generated from message fingertip.common.type.v1.EventType
 */
export const EventType = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.EventType",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "locations", kind: "message", T: EventLocation, repeated: true },
    { no: 6, name: "length", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "offset_start", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "hidden", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "site_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "booking_fields", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "period_type", kind: "enum", T: proto3.getEnumType(PeriodType) },
    { no: 16, name: "period_start_date", kind: "message", T: Timestamp },
    { no: 17, name: "period_end_date", kind: "message", T: Timestamp },
    { no: 18, name: "period_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 19, name: "period_count_calendar_days", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 20, name: "requires_confirmation", kind: "message", T: BoolValue },
    { no: 21, name: "requires_booker_email_verification", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 22, name: "recurring_event", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "disable_guests", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 24, name: "hide_calendar_notes", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 25, name: "minimum_booking_notice", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 26, name: "before_event_buffer", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 27, name: "after_event_buffer", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 28, name: "seats_per_time_slot", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 29, name: "seats_show_attendees", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 30, name: "seats_show_availability_count", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 31, name: "scheduling_type", kind: "enum", T: proto3.getEnumType(SchedulingType) },
    { no: 33, name: "slot_interval", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 34, name: "metadata", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 35, name: "success_redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 36, name: "booking_limits", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 37, name: "duration_limits", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 38, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 39, name: "created_at", kind: "message", T: Timestamp },
    { no: 40, name: "updated_at", kind: "message", T: Timestamp },
    { no: 41, name: "price_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 42, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 43, name: "maximum_booking_window", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 44, name: "refundable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 52, name: "attendance_type", kind: "enum", T: proto3.getEnumType(AttendanceType) },
    { no: 53, name: "max_attendees", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 54, name: "media", kind: "message", T: Media },
    { no: 55, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 56, name: "show_attendee_count", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 57, name: "archived_at", kind: "message", T: Timestamp },
    { no: 59, name: "form_template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 60, name: "disable_reschedule", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

